import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { VueHeadMixin } from "@unhead/vue";
import { createHead } from "@unhead/vue/client";
import { createPlausible } from "v-plausible/vue";
import vuetify from "@/plugins/vuetify";
import { HighchartsVue } from "@/plugins/highcharts";

const app = createApp(App);

// Register Highcharts globally
app.use(HighchartsVue);

app.use(vuetify);

// Plausible tracking
const plausible = createPlausible({
  init: {
    domain:
      process.env.NODE_ENV === "production"
        ? "nowcastinglab.org"
        : "dev.nowcastinglab.org",
    trackLocalhost: true,
  },
  settings: {
    enableAutoOutboundTracking: false,
    enableAutoPageviews: false,
  },
  partytown: false,
});

app.use(plausible);

const head = createHead();
app.use(head);
app.mixin(VueHeadMixin);

const pinia = createPinia();
app.use(pinia);
app.use(router);

app.mount("#app");
